import React, { useEffect, useState } from "react"

import Space from "./space"
import Text from "./text"
import { useIsScreenDesktop } from "./../utils/view"

type Props = {
  headings: string[]
  isPremiumArticle: boolean
}

const ArticleHeadings: React.FC<Props> = ({ headings, isPremiumArticle }) => {
  const [isClosed, setClosed] = useState(false)
  const toggleClosed = () => {
    setClosed(!isClosed)
  }
  const isScreenDesktop = useIsScreenDesktop()
  useEffect(() => {
    // モバイルは目次が閉じている状態にする（プレミアム記事以外）
    if (!isPremiumArticle) {
      setClosed(!isScreenDesktop)
    }
  }, [isScreenDesktop, isPremiumArticle])

  return (
    <div className="bg-gray-100 py-4 px-6 rounded">
      <div className="flex space-x-2 items-center">
        <Text fontSize="sm" fontBold={true}>
          目次
        </Text>
        {!isPremiumArticle && (
          <div className="cursor-pointer" onClick={toggleClosed}>
            <Text fontSize="sm">{isClosed ? "[表示]" : "[非表示]"}</Text>
          </div>
        )}
      </div>
      <div style={{ display: isClosed ? "none" : "" }}>
        <Space sizeY="4" />
        <ol>
          {headings.map((heading, i) => {
            return (
              <li
                className="font-hiragino text-sm text-gray-700 mb-1.5"
                key={`article-heading-${i}`}
              >
                <span className="font-avenir">{i + 1}.</span>
                {isPremiumArticle ? (
                  <span
                    className="no-underline pb-1 border-b-0.5 border-gray-700"
                  >
                    {heading}
                  </span>
                ) : (
                  <a
                    className="no-underline pb-1 border-b-0.5 border-gray-700"
                    href={`#Heading-${i}`}
                  >
                    {heading}
                  </a>
                )}
              </li>
            )
          })}
        </ol>
      </div>
    </div>
  )
}

export default ArticleHeadings
